window.dataLayer = window.dataLayer || []

/**
 * @description: PDP Select Size
 */
if (document.querySelector('[data-ga-el="pdpSizeClick"]')) {
  document.querySelectorAll('[data-ga-el="pdpSizeClick"]').forEach(input => {
    input.addEventListener('click', e => {
      window.dataLayer.push({
        event: 'pdp_size_click',
        pdpSize: {
          size_availability: e.currentTarget.dataset.gaVariableAvailable,
          product_name: e.currentTarget.dataset.gaVariableProduct,
          size_selected: e.currentTarget.dataset.gaVariableSize,
        },
      })
    })
  })
}

/**
 * @description: PDP Carousel
 */
if (document.querySelector('[data-ga-el="imageSlidePDP"]')) {
  document.querySelectorAll('[data-ga-el="imageSlidePDP"]').forEach(slide => {
    let isThrottled = false
    const throttleInterval = 2000 // Throttle interval in milliseconds

    slide.addEventListener('touchmove', (event) => {
      if (!isThrottled) {
        // Run your callback function here
        const currentTarget = event.currentTarget
        const productName = currentTarget.dataset.gaVariableProduct
        const slideIndex = currentTarget.dataset.gaElIndex + 1

        window.dataLayer.push({
          event: 'gallery_image_swipe_pdp',
          pdpGallerySwipe: {
            product_name: productName,
            slide_index: slideIndex,
          },
        })

        // Set throttled state
        isThrottled = true

        // Schedule next execution
        setTimeout(() => {
          isThrottled = false
        }, throttleInterval)
      }
    })
  })
}

/**
 * @description: Globo Back In Stock
 */

// Watch for the Globo modal trigger to load, then add event listener
(function () {
  const observerConfig = {
    childList: true,
    subtree: true,
  }

  const observer = new MutationObserver((mutations) => {
    let eventAdded = false

    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const globoWrapper = document.querySelector('#Globo-Back-In-Stock')

        if (globoWrapper) {
          const globoModalTrigger = globoWrapper.querySelector('.gBackInStockBtn')

          if (globoModalTrigger && !eventAdded) {
            handleNotifyMeOpen(globoModalTrigger)

            eventAdded = true
            observer.disconnect()
          }
        }
      }
    })
  })

  observer.observe(document, observerConfig)
})()

function handleNotifyMeOpen (notifyMeTriggerEl) {
  notifyMeTriggerEl.addEventListener('click', event => {
    watchForGloboModal()

    const product = window.Globo?.Preorder.settings.product
    const { handle, id, title, price } = product

    const variantInputs = [...document.querySelectorAll('[data-ga-el="pdpSizeClick"]')]
    const hasVariants = variantInputs.length > 0
    const selectedVariant = hasVariants ? variantInputs.filter(input => input.checked)[0] : product.variants[0]
    const selectedVariantId = hasVariants ? selectedVariant?.dataset.variantId : selectedVariant?.id
    const selectedVariantTitle = hasVariants ? selectedVariant?.value : selectedVariant?.title

    window.dataLayer.push({
      event: 'notify_me_open_pdp',
      notifyMeOpenPdp: {
        item: {
          product_handle: handle,
          product_id: id,
          product_title: title,
          variant_title: selectedVariantTitle,
          variant_id: selectedVariantId,
          price: price / 100,
        },
      },
    })
  })
}

// Watch for the Globo modal trigger to load, then add event listener
function watchForGloboModal () {
  const observerConfig = {
    childList: true,
    subtree: true,
  }

  const observer = new MutationObserver((mutations) => {
    let eventAdded = false

    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const globoModalWrapper = document.querySelector('#Globo-Back-In-Stock-Popup')

        if (globoModalWrapper) {
          const globoSubmitButton = globoModalWrapper.querySelector('.Globo-content-button')

          if (globoSubmitButton && !eventAdded) {
            handleNotifyMeSubmit(globoSubmitButton)

            eventAdded = true
            observer.disconnect()
          }
        }
      }
    })
  })

  observer.observe(document, observerConfig)
}

function handleNotifyMeSubmit (globoSubmitButton) {
  globoSubmitButton.addEventListener('click', event => {
    const eventName = 'notify_me_submit_pdp'
    const eventIsPushed = window.dataLayer?.filter(obj => obj.event === eventName).length > 0

    if (eventIsPushed) return

    const product = window.Globo?.Preorder.settings.product
    const { handle, id, title, price } = product

    const variantInputs = [...document.querySelectorAll('[data-ga-el="pdpSizeClick"]')]
    const hasVariants = variantInputs.length > 0
    const selectedVariant = hasVariants ? variantInputs.filter(input => input.checked)[0] : product.variants[0]
    const selectedVariantId = hasVariants ? selectedVariant?.dataset.variantId : selectedVariant?.id
    const selectedVariantTitle = hasVariants ? selectedVariant?.value : selectedVariant?.title

    window.dataLayer.push({
      event: eventName,
      notifyMeSubmitPdp: {
        item: {
          product_handle: handle,
          product_id: id,
          product_title: title,
          variant_title: selectedVariantTitle,
          variant_id: selectedVariantId,
          price: price / 100,
        },
      },
    })
  })
}

/**
 * @description: PDP accordion Click
 */
const accordionEls = document.querySelectorAll('[data-ga-el="pdpDetailsAccordion"]')
if (accordionEls.length > 0) {
  accordionEls.forEach(accordionEl => {
    accordionEl.addEventListener('click', e => {
      const clickedAccordion = e.target.closest('[data-ga-el="pdpDetailsAccordion"]')
      const isExpanded = clickedAccordion.getAttribute('aria-expanded') === 'false'
      const clickTitle = clickedAccordion.dataset.gaVariableTitle
      const clickAction = isExpanded ? 'open' : 'close'

      window.dataLayer.push({
        event: 'pdp_accordion',
        pdpAccordion: {
          accordion_name: clickTitle || '',
          click_action: clickAction,
        },
      })
    })
  })
}

/**
 * @description: Product details description - 'Style With' click
 */
const productDetailsDescriptionEl = document.querySelector('[data-ga-el="productDetailsDescription"]')
if (productDetailsDescriptionEl) {
  productDetailsDescriptionEl.addEventListener('click', e => {
    const el = e.target

    if (!el.href) return

    const clickUrl = el.href
    const clickText = el.innerText || ''
    const productName = el.closest('[data-ga-product-title]')

    window.dataLayer.push({
      event: 'pdp_styled_with_click',
      pdpStyledWithClick: {
        click_url: clickUrl,
        click_text: clickText,
        product_name: productName.dataset.gaProductTitle,
      },
    })
  })
}

/**
 * @description: Size Guide Fit PDP
 */
const sizeGuideEl = document.querySelector('[data-ga-el="sizeGuidePopup"]')
if (sizeGuideEl) {
  sizeGuideEl.addEventListener('click', event => {
    window.dataLayer.push({
      event: 'pdp_size_guide_click',
      pdpSizeGuideClick: {
        item: event.target.dataset?.gaProduct,
      },
    })
  })
}

/**
 * @description: Concierge Interaction
 */
const conciergeEl = document.querySelector('[data-ga-el="concierge"]')
if (conciergeEl) {
  conciergeEl.addEventListener('click', event => {
    window.dataLayer.push({
      event: 'pdp_concierge_click',
      pdpConciergeClick: {
        item: event.target.dataset?.gaProduct,
      },
    })
  })
}
